var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('button',{staticClass:"topButton",on:{"click":function($event){return _vm.topButton()}}},[_c('span',{staticClass:"hidden"},[_vm._v("상단으로 바로가기")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }